import React, { useEffect, useState, useRef, useCallback } from "react";
import NewsItem from "./NewsItem";
import LoadingBar from "react-top-loading-bar";
import axios from 'axios';


export default function News(props) {
    const [articles, setArticles] = useState([]);
    const [totalResults, setTotalResults] = useState(0);
    const [page, setPage] = useState(1);
    const [loading, setLoading] = useState(false);

    const hasFetched = useRef(false);
    const [progress, setProgress] = useState(0);

    const updateNews = useCallback(async (pagenum = page) => {
        try {
            setLoading(true);
            setProgress(10);
            const url = `https://newsapi.org/v2/top-headlines?apiKey=55e5f4ea53194002b1f554810d5fbf76&category=${props.category}&page=${pagenum}&pageSize=${props.pageSize}`;
            //   const url = `https://newsapi.org/v2/top-headlines?apiKey=d1a02cfac47b49dd9d8921601111fab6&category=${props.category}&page=${pagenum}&pageSize=${props.pageSize}`;
            // const url = `https://newsapi.org/v2/top-headlines?country=in&category=${props.category}&apiKey=55e5f4ea53194002b1f554810d5fbf76&page=${page}&pagesize=${props.pageSize}`;

            const fetchdata = async () => {
                try {
                    const response = await axios.get(url);
                    console.log("Fetching:", url);
                    setProgress(50);
                    console.log(response.data);
                    // let parseData = await data.json();
                    setProgress(80);
                    setArticles(response.data.articles);
                    setTotalResults(response.data.totalResults);
                    setProgress(100);
                    setLoading(false);
                } catch (error) {
                    setProgress(100);
                    console.log(error);
                }
            }
            fetchdata();





        } catch (err) {
            console.error("Error fetching news:", err);
            setLoading(false);
            setProgress(100);
        }
    },[page , props.pageSize,props.category]);

    useEffect(() => {
        if (!hasFetched.current) {
            hasFetched.current = true;
            updateNews(page);
        }
    }, [updateNews, page]);

    const nextClick = () => {
        const newPage = page + 1;
        setPage(newPage);
        updateNews(newPage);
    };

    const prevClick = () => {
        const newPage = page - 1;
        setPage(newPage);
        updateNews(newPage);
    };

    return (
        <>
            <LoadingBar
                color="#f11946"
                progress={progress}
                onLoaderFinished={() => setProgress(0)}
            />

            <div className="container my-2">
                <h3 className="text-center mb-3">Top Headlines</h3>
                <div className="row">
                    {loading ? (
                        <div className="text-center"><span className="text-muted">Loading...</span></div>
                    ) : articles.length > 0 ? (
                        articles.map((item) => (
                            <NewsItem
                                key={item.url}
                                title={item.title || ""}
                                description={item.description || ""}
                                imageurl={item.urlToImage || ""}
                                newsUrl={item.url}
                            />
                        ))
                    ) : (
                        <span className="text-xs font-weight-bold">No records</span>
                    )}
                </div>

                <div className="d-flex justify-content-between">
                    <button
                        type="button"
                        disabled={page <= 1}
                        className="btn btn-sm btn-dark"
                        onClick={prevClick}
                    >
                        &larr; Previous
                    </button>

                    <button
                        type="button"
                        disabled={Math.ceil(totalResults / props.pageSize) === page}
                        className="btn btn-sm btn-dark"
                        onClick={nextClick}
                    >
                        Next &rarr;
                    </button>
                </div>
            </div>
        </>
    );
}